import { PRestartLogo } from '@/assets/branding/project-restart';

const colors = {
  // Brand colors
  brand_primary: '#FF0000',
  brand_primary_hover: '#CC0000',
  brand_primary_highlight: '#FFB3B3',
  brand_primary_mid: '#FF4D4D',
  brand_primary_dark: '#660000',
  brand_secondary: '#C62828',
  brand_accent_start: '#FF2B2B',
  brand_accent_end: '#F59E0B',
  brand_accent_light_start: '#FFEDEE',
  brand_accent_light_end: '#FFE8CC',
  brand_complementary_accent: 'rgb(20,255,255)',
  brand_auth_gradient_mid: '#C62828',
  brand_auth_gradient_end: '#660000',
  brand_auth_warp_mid: '#FF4D4D',
};

export default {
  name: 'Project Restart',
  isSAML: true,
  allowPersonalCourses: false,
  logo: PRestartLogo,
  colors,
};
